import * as React from "react";
import * as ReactDOM from "react-dom";
import LicensePlateLookupComponentReact from "./LicensePlateLookupComponentReact";
import { ReactComponent } from "react-formio";
import settingsForm from "./LicensePlateLookup.settingsForm";

export default class LicensePlateLookupComponent extends ReactComponent {
  private root: any;
  private component: any;
  private dataValue: any;
  private updateValue: any;
  private id: string;
  private on: Function;
  private error: any;
  private reactInstance: LicensePlateLookupComponentReact;

  static schema(...extend) {
    const schema = ReactComponent.schema(
        {
          type: "licensePlateLookup",
          key: "licensePlateLookup",
          label: "LicensePlate",
          placeholder: "LicensePlate"
        },
        ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: "License Plate Lookup",
      group: "advanced",
      icon: "car",
      weight: -10,
      schema: LicensePlateLookupComponent.schema()
    };
  }

  static editForm = settingsForm;

  focus() {
    if (this.reactInstance) {
      this.reactInstance.focus();
    }
  }

  init() {
    this.on("validationFinished", event => {
      if (this.reactInstance && this.reactInstance.setState) {
        this.reactInstance.setState({ isValid: !this.error });
      }
    });
  }

  attachReact(element) {
    return ReactDOM.render(<LicensePlateLookupComponentReact value={this.dataValue} component={this.component} form={this} onChange={this.updateValue} isValid={!this.error}  />, element);
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
